import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';
import {bool, string} from 'prop-types';

import LastActualizationInformation from './LastActualizationInformation';
import {projectShape} from '../../../../proptypes-shapes';
import {getHumanReadableSiren} from '../../../../utils';

const ProjectSiren = muiStyled(Typography)(({theme}) => ({
  fontSize: 12,
  color: theme.palette.grey['400'],
  lineHeight: 1,
  whiteSpace: 'nowrap'
}));

const ProjectInfo = ({isDemo, siren, project, isList}) => {
  if (isDemo && !isList) {
    return null;
  }

  if (isDemo) {
    return <LastActualizationInformation hasStartingSeparator={false} project={project} />;
  }

  return (
    <Grid container alignItems="center" gap={isList ? 0 : 1} flexWrap="nowrap">
      <ProjectSiren component="div" variant="h6">
        {getHumanReadableSiren(siren)}
      </ProjectSiren>
      {isList && <LastActualizationInformation hasStartingSeparator project={project} />}
    </Grid>
  );
};

ProjectInfo.propTypes = {
  isDemo: bool.isRequired,
  siren: string.isRequired,
  project: projectShape.isRequired,
  isList: bool.isRequired
};

export default ProjectInfo;
